export const GREEN = '#45D695';
export const BLUE = '#3F95DC';
export const YELLOW = '#ECC434';
export const RED = '#E54F3A';
export const WHITE = '#ffffff';
export const BLACK = '#2F313C';
export const GREY = '#D5D5D5';
export const TACTICAL_RED = '#F70E1E';



// WEBPACK FOOTER //
// ./library/app/components/Diagram/ItemColors.js